
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shyftpass/[slug]",
      function () {
        return require("private-next-pages/shyftpass/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shyftpass/[slug]"])
      });
    }
  